import {I18nKV} from "./i18nInterface";

const i18nKv: I18nKV = {
    // '模糊搜索:': ['模糊搜索:', '模糊檢索:', 'Search:'],
    // '点击输入要搜索的接口': ['点击输入要搜索的接口', '輸入要檢索的接口', 'Enter the interface to search'],
    // '框架内容': ['框架内容', '框架內容', 'Frame content'],
    // '游戏设置': ['游戏设置', '遊戲設定', 'Game setting'],
    // '取消': ['取消', '取消', 'Cancel'],
    // '简体中文': ['简体中文', '简体中文', '简体中文'],
    // '繁體中文': ['繁體中文', '繁體中文', '繁體中文'],
    // '繁体中文': ['繁體中文', '繁體中文', '繁體中文'],
    // 'English': ['English', 'English', 'English'],
    // '语言': ['语言', '語言', 'Language'],
    // '请选择语言': ['请选择语言', '請選擇語言', 'Select Language'],
    // '设置成功': ['设置成功', '設置成功', 'Success'],
    // '需要重启后生效': ['需要重启后生效', '需要重啟后生效', 'Effective after restart'],
    // '立即重启': ['立即重启', '立即重啟', 'Restart'],
    // '然后重启': ['然后重启', '然後重啟', 'Later'],
    // '我的操作': ['我的操作', '', 'My operation'],
    // '“关键字”查找结果': ['“關鍵字”查找結果', '', 'Keyword search results'],
    // '关闭': ['关闭', '關閉', 'close'],
    // '确认框': ['确认框', '確認框', 'Confirmation box'],
    // '确定取消框': ['确定取消框', '確定取消框', 'OK cancel box'],
    // '看一次视频': ['看一次视频', '看一次視頻', 'Watch a video'],
    // '看多次视频': ['看多次视频', '看多次視頻', 'Watch videos many times'],
    // '3秒加载完': ['3秒加载完', '3秒加載完', 'Load in 3 seconds'],
    // '画板预制': ['画板预制', '畫板預製', 'Drawing board prefabrication'],
    // '新手手势': ['新手手势', '新手手勢', 'Novice gesture'],
    // '星星粒子': ['星星粒子', '星星粒子', 'Star particle'],
    // '彩带粒子': ['彩带粒子', '綵帶粒子', 'Ribbon particle'],
    // '版本公告': ['版本公告', '版本公告', 'Version announcement'],
    // '选择框': ['选择框', '選擇框', 'Selection box'],
    // '开始直播': ['开始直播', '開始直播', 'Start live broadcast'],
    // 'banner广告': ['banner广告', 'banner廣告', 'Banner advertising'],
    // 'native广告': ['native广告', 'native廣告', 'Native advertising'],
    // '添加桌面': ['添加桌面', '添加桌面', 'Add desktop'],
    // '视频列表': ['视频列表', '視頻列表', 'Video list'],
    // '订阅消息': ['订阅消息', '訂閱消息', 'Subscribe to messages'],
    // '添加到收藏': ['添加到收藏', '添加到收藏', 'Add to collection'],
    // '互跳1': ['互跳1', '互跳1', 'Mutual jump 1'],
    // '互跳2': ['互跳2', '互跳2', 'Mutual jump 2'],
    // '互跳3': ['互跳3', '互跳3', 'Mutual jump 3'],
    // '录音变声': ['录音变声', '錄音變聲', 'Recording sound change'],
    // '短振动': ['短振动', '短振動', 'Short vibration'],
    // '长振动': ['长振动', '長振動', 'Long vibration'],
    // '敏感词汇': ['敏感词汇', '敏感詞彙', 'Sensitive vocabulary'],
    // '开始录屏': ['开始录屏', '開始錄屏', 'Start screen recording'],
    // '停止录屏': ['停止录屏', '停止錄屏', 'Stop screen recording'],
    // '分享录屏': ['分享录屏', '分享錄屏', 'Share recording screen'],
    // '提交排行榜': ['提交排行榜', '提交排行榜', 'Submit Leaderboard'],
    // '展示排行榜': ['展示排行榜', '展示排行榜', 'Show Leaderboard'],
    // '发送埋点': ['发送埋点', '發送埋點', 'Send buried point'],
    // '格子跳转': ['格子跳转', '格子跳轉', 'Grid jump'],
    // '轮播弹窗跳转': ['轮播弹窗跳转', '輪播彈窗跳轉', 'Rotation pop-up jump'],
    // '侧拉栏跳转': ['侧拉栏跳转', '側拉欄跳轉', 'Sidebar jump'],
    // '迷宫': ['迷宫', '迷宮', 'maze'],
    // '炫彩粒子': ['炫彩粒子', '炫彩粒子', 'Atomus HD'],
    // '内网聊天': ['内网聊天', '內網聊天', 'Intranet chat'],
    // '联机对战': ['联机对战', '聯機對戰', 'Online battle'],
    // 'UI操作': ['UI操作', 'UI操作', 'UI'],
    // '我的应用': ['我的应用', '我的應用', 'My application'],
    // '平台相关': ['平台相关', '平臺相關', 'Platform related'],
    // '内置模式': ['内置模式', '內置模式', 'Built in mode'],
    // '音效': ['音效', '音效', 'Sound'],
    // '振动': ['振动', '振動', 'Vibration'],
    // '语言选择': ['语言选择', '語言選擇', 'Language'],
    // '隐私政策': ['隐私政策', '隱私政策', 'Privacy policy'],
    // '用户协议': ['用户协议', '用戶協議', 'User agreement'],
}

export default function (): I18nKV {
    return i18nKv;
}


























































































